$(document).ready(function(){

  $("#more-wrapp").click(function(){
    $('.less-wrapp').addClass("hide");
    $('.full-wrapp').addClass("active");
  });
  $("#less-wrapp").click(function(){
    $('.less-wrapp').removeClass("hide");
    $('.full-wrapp').removeClass("active");
  });
  
  
  /* collection JS*/
  $(".readmore_desc").click(function(){
      $(this).parents().addClass('hide');
      $(this).parents().next().addClass('show');
    });

  /* product JS*/

  /* Newsletter on Homepage & Blog JS */

  var $form = $('form#mc-embedded-subscribe-form');
  console.log('form Home & Blog:'+$form.length);
  if ( $form.length > 0 ) {
      $form.find('input[type="submit"]').bind('click', function ( event ) {
          if ( event ) event.preventDefault();
          var validEmail = isValidEmailAddress($form.find('input[type="email"]').val());
          if($form.find('input[type="email"]').val().indexOf('taminoautographs') != -1){
             validEmail = false;
          }
          console.log(validEmail);
          if(validEmail)
          {
             register_mailchimp($form);
          }else{
            $form.find('#ajax_message').html("Please enter a valid email address").css('color','red');
            $form.find('input[type="email"]').focus();
          }
      });
  }

  /* Newsletter Article bottom JS */

  var $formArticle = $('form#mc-embedded-subscribe-form-article');
  console.log('form Article:'+$formArticle.length);
  if ( $formArticle.length > 0 ) {
      $formArticle.find('input[type="submit"]').bind('click', function ( event ) {
          if ( event ) event.preventDefault();
          var validEmail = isValidEmailAddress($formArticle.find('input[type="email"]').val());
          if($formArticle.find('input[type="email"]').val().indexOf('taminoautographs') != -1){
             validEmail = false;
          }
          console.log(validEmail);
          if(validEmail)
          {
             register_mailchimp($formArticle);
          }else{
            $formArticle.find('#ajax_message').html("Please enter a valid email address").css('color','red');
            $formArticle.find('input[type="email"]').focus();
          }
      });
  }

   /* Newsletter Popup JS */

  var $formPopup = $('form#mc-embedded-subscribe-form-popup');
  console.log('form Popup:'+$formPopup.length);
  if ( $formPopup.length > 0 ) {
      $formPopup.find('input[type="submit"]').bind('click', function ( event ) {
          if ( event ) event.preventDefault();
          var validEmail = isValidEmailAddress($formPopup.find('input[type="email"]').val());
          if($formPopup.find('input[type="email"]').val().indexOf('taminoautographs') != -1){
             validEmail = false;
          }
          console.log(validEmail);
          if(validEmail)
          {
             register_mailchimp($formPopup);
          }else{
            $formPopup.find('#ajax_message').html("Please enter a valid email address").css('color','red');
            $formPopup.find('input[type="email"]').focus();
          }
      });
  }
  
  function register_mailchimp($form) {
      $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: $form.serialize(),
          cache       : false,
          dataType    : 'json',
          contentType: "application/json; charset=utf-8",
          error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
          success     : function(data) {
          console.log(data);
          if (data.result != "success") 
          {
            $form.find('#ajax_message').css('color','red');
            $form.find('#ajax_message').html(data.msg);
          } 
          else 
          {
            $form.find('#ajax_message').css('color','green');
            $form.find('#ajax_message').html(data.msg);
          }
        }
      });
  }
  
  function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
  }

});
